import React, { useEffect, useState } from "react";
// @ts-ignore
import { tw } from "@careinfo/tailwind";
import moment from "moment";
import { getColorForLetter } from "../utils";
import { useLocation } from "react-router-dom";
import { getEmailFolderId } from "../layouts/DashboardLayout";

interface EmailsProps {
  mails: any;
  setSelectedEmail: (id: string | null) => void;
  isLoading?: boolean;
}

const Emails: React.FC<EmailsProps> = ({
  mails,
  setSelectedEmail,
  isLoading = false,
}) => {
  const [Star, setStar] = useState<Record<number, boolean>>({});
  const loaction = useLocation();
  const foldersId: any = getEmailFolderId();

  useEffect(() => {
    setSelectedEmail(null);
  }, [loaction.pathname]);

  const handleStar = (index: number) => {
    setStar((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  if (isLoading) {
    return (
      <div className={tw`flex justify-center items-center h-[70vh]`}>
        <div
          className={tw`animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-primary`}
        />
      </div>
    );
  }

  if (!mails?.results?.length) {
    return (
      <p className={tw`text-center text-gray-500 mt-10`}>No emails found</p>
    );
  }

  const emailList = mails.results;

  return (
    <div>
      {emailList.map((email: any, idx: number) => {
        const senderName =
          email.from?.[0]?.name || email.from?.[0]?.email || "?";
        const receiverName = email.to?.[0]?.name || email.to?.[0]?.email || "?";
        const letter =
          location.pathname !== `/mail/${foldersId?.Sent}`
            ? senderName?.[0]?.toUpperCase() ?? "?"
            : receiverName?.[0]?.toUpperCase() ?? "?";
        const color = getColorForLetter(letter);

        return (
          //addded less opacity to read email
          <div
            key={email.id}
            onClick={() => {
              setSelectedEmail(email.id);
            }}
            className={tw`cursor-pointer border-b-2 flex items-center gap-x-2 px-2 py-2 bg-[#FEFEFE] hover:bg-gray-50 ${
              location.pathname !== `/mail/${foldersId?.Sent}`
                ? email.keywords.$seen
                  ? "opacity-60"
                  : "opacity-100"
                : "opacity-60"
            }`}
          >
            <div
              className={tw`w-10 h-10 rounded-full flex items-center justify-center text-white font-semibold`}
              style={{ backgroundColor: color }}
            >
              {letter}
            </div>

            <div>
              <h3 className={tw`text-[16px]`}>
                {location.pathname !== `/mail/${foldersId?.Sent}`
                  ? senderName
                  : `To: ${receiverName}`}
              </h3>
              <p className={tw`text-[12px] text-gray-700`}>{email.subject}</p>
            </div>

            <div className={tw`ml-auto text-right`}>
              <p
                className={tw`cursor-pointer text-xl ${
                  Star[idx] ? "text-yellow-300" : "text-gray-400"
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleStar(idx);
                }}
              >
                {Star[idx] ? "★" : "☆"}
              </p>

              <p className={tw`text-gray-500 text-[12px]`}>
                {moment(email.receivedAt).format("DD/MM/YYYY HH:mm")}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Emails;
